import { api } from '@/services';
import type {
  ApuracaoAssistidaResponse,
  SituacaoSolicitacaoResponse,
  SolicitacaoAbertaResponse,
} from '../types';

const BASE = 'TurboPro/ApuracaoAssistidaCBS';

const somenteDigitos = (cnpj: string) => cnpj.replace(/\D/g, '');

export const fetchUltimaApuracaoAssistida = (cnpjContribuinte: string) =>
  api.get<ApuracaoAssistidaResponse>(
    `${BASE}/Ultima?cnpjContribuinte=${encodeURIComponent(somenteDigitos(cnpjContribuinte))}`
  );

export const solicitarApuracaoAssistida = (cnpjContribuinte: string) =>
  api.post<SolicitacaoAbertaResponse, { CNPJ_Contribuinte: string }>(`${BASE}/Solicitar`, {
    CNPJ_Contribuinte: somenteDigitos(cnpjContribuinte),
  });

export const consultarSituacaoApuracaoAssistida = (cnpjContribuinte: string, tiquete: string) =>
  api.get<SituacaoSolicitacaoResponse>(
    `${BASE}/Situacao?cnpjContribuinte=${encodeURIComponent(somenteDigitos(cnpjContribuinte))}` +
      `&tiquete=${encodeURIComponent(tiquete)}`
  );
